import { CurrentUserAvatarProps } from "./CurrentUserAvatar.types";
import { UserAvatar } from "../UserAvatar";
import { useUserAttributes } from "@facade/queries";

function CurrentUserAvatar(props: CurrentUserAvatarProps) {
  const { data: attributes, isLoading } = useUserAttributes(true);

  return (
    <UserAvatar
      name={attributes?.name}
      email={attributes?.email}
      firstName={attributes?.given_name}
      lastName={attributes?.family_name}
      pictureAttachmentId={attributes?.picture}
      isLoading={isLoading}
      {...props}
    />
  );
}

export { CurrentUserAvatar };
